<main class="main-container">

  <app-header class=""></app-header>
  <app-toolbar class=""></app-toolbar>
  <app-toolbar-sub class=""></app-toolbar-sub>
  
  <div class="planning w-full ">
  
  
    <div class="planning-table grid-flow-row border-r-4 border-[#27368A]">
  
      <div
        class="planning-title h-16 p-3 border-b-4 border-[#27368A] flex flex-row justify-between align-middle items-center">
        <h4 class="text-xl font-bold text-[#27368A]">Planning</h4>
        <div class="search-box flex align-middle  bg-[#F3F3F3] border-2 border-[#27368A] rounded-2xl w-64 h-10 pl-8">
          <input #filter [(ngModel)]="searcherCriteria" (input)="planningService.filterPlanningResult(searcherCriteria)"
            class="col-span-4 bg-[#F3F3F3] w-52 font-bold border-0 outline-none" placeholder="Buscar titular/dni">
        </div>
      </div>
      <app-cardtable [datacolumns]="toolbarFiltersTable && toolbarFiltersTable.getColumns()" [bookingsData]="bookingsData" [dataactions]="toolbarFiltersTable.getActions()"
        [globalfilters]="toolbarFiltersTable.getGlobalFilters()" [searcher]="searcherCriteria"
        [datavalues]="filteredPlanningData" [showActionLabels]="true" size="small"
        style="width: max-content; height: fit-content;">
  
      </app-cardtable>
  
    </div>
  
    <div class="inventories-table w-full">
  
      <div class="inventories-title h-16 p-3 mb-0 border-b-4 border-[#27368A] align-middle items-center">
        <h4 class="text-xl font-bold text-[#27368A]">Inventario</h4>
      </div>
  
      <div class="p-3">
        <div class="grid-rows-1 flex flex-row gap-2 h-16 mb-0">
          <img class="h-14 w-14" src="assets/icons/icon_canoe_blue.png" alt="">
          <img class="h-14 w-14" src="assets/icons/icon_jetski_blue.png" alt="">
          <img class="h-14 w-14" src="assets/icons/icon_rafting_blue.png" alt="">
        </div>
  
        <div class="grid-rows-1 flex flex-row gap-2 mt-0 items-center align-middle h-5">
          <p class="count-inventories font-extrabold text-lg text-gray-500">x12 Salvavidas XL - </p>
          <p class="store font-semibold text-gray-500"> ALMACÉN SELLA</p>
        </div>
  
      </div>
  
    </div>
  
  </div>
</main>